const INITIAL_STATE = {
    readOnly: { values: [], error: null, loading: false },
  };
  
  export default function (state = INITIAL_STATE, action) {
    return {
      ...state,
      readOnly: { values: action.payload, error: null, loading: true },
    };
  }
  